<template>
  <div class="tu-show-more">
    <button type="button" class="tu-show-more__btn" :disabled="loading" @click="$emit('more')">
      {{ loading ? 'Loading…' : `Show More ${noun}` }}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 9 7 7 7-7"/></svg>
    </button>
    <p v-if="total != null" class="tu-show-more__count">Showing {{ Number(shown).toLocaleString('en-US') }} of {{ Number(total).toLocaleString('en-US') }} {{ noun }}</p>
  </div>
</template>

<script>
/**
 * The one "show more" control, used under every list on the site: a white pill with the
 * chevron, and the "Showing X of Y" line when the total is known.
 */
export default {
  name: 'TuShowMore',
  props: {
    /** Plural noun, lower case: programs, schools, articles, tools */
    noun: { type: String, default: 'results' },
    shown: { type: Number, default: 0 },
    total: { type: Number, default: null },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.tu-show-more { display: grid; justify-items: center; gap: 12px; margin-top: 28px; }
.tu-show-more__btn { display: inline-flex; align-items: center; gap: 12px; border: 0; border-radius: 14px; padding: 12px 20px; background: var(--tu-surface); color: var(--tu-blue); font-family: var(--tu-font-text); font-size: 16px; font-weight: 600; text-transform: capitalize; cursor: pointer; box-shadow: 0 1px 2px rgba(24, 24, 24, .06); transition: background .15s ease, color .15s ease; }
.tu-show-more__btn:hover { background: var(--tu-blue-tint); color: var(--tu-blue-deep); }
.tu-show-more__btn:disabled { opacity: .6; cursor: default; }
.tu-show-more__btn:focus-visible { outline: 2px solid var(--tu-blue); outline-offset: 3px; }
.tu-show-more__count { margin: 0; font-size: 13px; color: var(--tu-ink-soft); }
</style>
